import React from "react";
import { arrayOf, func, object } from "prop-types";
import { twMerge } from "tailwind-merge";

const SlotPicker = ({ slots, onSlotChange, selectedSlot }) => {
  return (
    <div className="flex flex-wrap gap-2 pt-2">
      {slots
        .filter(slot => slot.driversSlotsAvailable !== 0)
        .map(slot => (
          <button
            className={twMerge(
              "px-2 py-1 rounded-sm text-sm font-semibold cursor-pointer transition duration-150 hover:scale-105 active:scale-95",
              selectedSlot?.name === slot.name
                ? "bg-primaryOrange text-white"
                : "bg-greyLight text-primaryDark hover:bg-greyMedium"
            )}
            key={slot.name}
            onClick={() => onSlotChange(slot)}
          >
            {slot.name.replace(/\s/g, "-")}
          </button>
        ))}
    </div>
  );
};

SlotPicker.propTypes = {
  slots: arrayOf(object).isRequired,
  selectedSlot: object,
  onSlotChange: func,
};

export default SlotPicker;
